function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from "react";
import { KeyboardEventKeys } from "../../typings/types";
import isNotEmpty from "../../utils/isNotEmpty";
export var checkIsLastFocusableElementInWrapper = function checkIsLastFocusableElementInWrapper(focusEvent, wrapperRef) {
  var _wrapperRef$current;
  if (!isNotEmpty(wrapperRef.current)) {
    return false;
  }
  if (!((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(focusEvent.relatedTarget))) {
    return true;
  }
  return false;
};
export var getFocusableElementsInWrapper = function getFocusableElementsInWrapper(wrapperElement, withHiddenElements) {
  if (!isNotEmpty(wrapperElement)) {
    return [];
  }
  return Array.from(wrapperElement.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')).filter(function (element) {
    if (element.getClientRects().length === 0) return false;
    if (element.tabIndex === -1) return false;
    if ("disabled" in element && element.disabled) return false;
    var style = globalThis.getComputedStyle(element);
    if (!withHiddenElements && style.visibility === "hidden") return false;
    return style.display !== "none";
  });
};
export var getNextFocusable = function getNextFocusable(current) {
  var focusableElements = getFocusableElementsInWrapper(document);
  var idx = focusableElements.indexOf(current);
  if (document.activeElement === document.body) {
    return focusableElements[0];
  }
  if (idx === -1 || idx === focusableElements.length - 1) return null;
  return focusableElements[idx + 1];
};
export var getPrevFocusable = function getPrevFocusable(current) {
  var focusableElements = getFocusableElementsInWrapper(document);
  var idx = focusableElements.indexOf(current);
  if (idx <= 0) return null;
  return focusableElements[idx - 1];
};
export var focusFirstElementInWrapper = function focusFirstElementInWrapper(wrapperElement, isFocusWithTimeout) {
  var focusableElements = getFocusableElementsInWrapper(wrapperElement, true);
  if (focusableElements.length === 0) {
    return;
  }
  if (isFocusWithTimeout) {
    setTimeout(function () {
      return focusableElements[0].focus();
    }, 100);
  } else {
    focusableElements[0].focus();
  }
};
export var disableAllElementsFocusInWrapper = function disableAllElementsFocusInWrapper(wrapperElement, withHiddenElements) {
  var focusableElements = getFocusableElementsInWrapper(wrapperElement, withHiddenElements);
  focusableElements.forEach(function (focusableElement) {
    return focusableElement.setAttribute("tabindex", "-1");
  });
};
export function useFocusWrapper() {
  var focusWrapperRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isWrapperFocused = _useState2[0],
    setIsWrapperFocused = _useState2[1];
  var handleOnFocusWrapper = function handleOnFocusWrapper() {
    setIsWrapperFocused(true);
  };
  var handleOnBlurWrapper = function handleOnBlurWrapper(event) {
    var isLastFocusableElement = checkIsLastFocusableElementInWrapper(event, focusWrapperRef);
    if (isLastFocusableElement) {
      setIsWrapperFocused(false);
    }
  };
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === KeyboardEventKeys.ESC) {
        setIsWrapperFocused(false);
      }
    };
    if (isNotEmpty(focusWrapperRef.current) && isWrapperFocused) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isWrapperFocused]);
  return {
    focusWrapperRef: focusWrapperRef,
    isWrapperFocused: isWrapperFocused,
    handleOnFocusWrapper: handleOnFocusWrapper,
    handleOnBlurWrapper: handleOnBlurWrapper
  };
}